import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { keyLearningAreaService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as keyLearningAreasActions from './actions';

export function fetchKeyLearningAreas(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_KEY_LEARNING_AREAS),
    mergeMap(({ payload }) => {
      return keyLearningAreaService.getKeyLearningAreas(payload).pipe(
        map((res) =>
          keyLearningAreasActions.fetchKeyLearningAreasSuccess(
            res.responceObject.records
          )
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
export function fetchKeyLearningArea(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_KEY_LEARNING_AREA),
    mergeMap(({ payload }) => {
      return keyLearningAreaService.getKeyLearningAreasById(payload).pipe(
        map((res) =>
          keyLearningAreasActions.fetchKeyLearningAreaSuccess(
            res.responceObject.records
          )
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
